import React, { memo } from 'react';
import PropTypes from 'prop-types';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import CardImage from '../Views/CardImage';
import { vocabTitle } from '../../../helpers/content';

const FlexPeopleCard = memo(({ item, compact, hideLink }) => {
  // Link to profile page — either the is_linkable field on the object
  // (default: true) or the listing block's own "hide link" setting says no.
  const isLinkable = item.is_linkable !== false && !hideLink;

  const NameComponent = isLinkable ? (
    <UniversalLink href={item['@id']}>
      <h4 className="cards__title">
        {item.full_name ? item.full_name : item.id}
      </h4>
    </UniversalLink>
  ) : (
    <h4 className="cards__title cards__title--unlinked">
      {item.full_name ? item.full_name : item.id}
    </h4>
  );

  return (
    <div className="cards__item cards__item--grid-horizontal">
      {!compact && (
        <CardImage
          item={item}
          fallback={'/people_default_image.svg'}
          scalePreference={['mini']}
          containerClass="cards__image-container--left-people"
          href={isLinkable ? item['@id'] : undefined}
          alt={item.image_caption || item.full_name}
          width={126}
          height={188}
        />
      )}
      <div className="cards__content">
        {item.type_of_degree && (
          <p className="cards__info">{vocabTitle(item.type_of_degree)}</p>
        )}
        {NameComponent}
        {item.type_of_position && (
          <p className="cards__info">{vocabTitle(item.type_of_position)}</p>
        )}
      </div>
    </div>
  );
});

FlexPeopleCard.propTypes = {
  item: PropTypes.shape({
    '@id': PropTypes.string.isRequired,
    '@type': PropTypes.string,
    id: PropTypes.string,
    full_name: PropTypes.string,
    type_of_degree: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({ title: PropTypes.string }),
    ]),
    type_of_position: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({ title: PropTypes.string }),
    ]),
    image_caption: PropTypes.string,
    image_scales: PropTypes.object,
    is_linkable: PropTypes.bool,
  }).isRequired,
  compact: PropTypes.bool,
  hideLink: PropTypes.bool,
};

export default FlexPeopleCard;
